import {
  TELEGRAM_CHANNEL_BOT_TOKEN_CHANGE_CURRENT,
  TELEGRAM_CHANNEL_NAME_CHANGE_CURRENT,
  TELEGRAM_CHANNEL_BATCH_SIZE_CHANGE_CURRENT,
  TELEGRAM_CHANNEL_LIST_FETCH,
  TELEGRAM_CHANNEL_LIST_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_LIST_FETCH_FAIL,
  TELEGRAM_CHANNEL_CREATE_FETCH,
  TELEGRAM_CHANNEL_CREATE_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_CREATE_FETCH_FAIL,
  TELEGRAM_CHANNEL_INFO_FETCH,
  TELEGRAM_CHANNEL_INFO_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_INFO_FETCH_FAIL,
  TELEGRAM_CHANNEL_DELETE_FETCH,
  TELEGRAM_CHANNEL_DELETE_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_DELETE_FETCH_FAIL,
  TELEGRAM_CHANNEL_UPDATE_FETCH,
  TELEGRAM_CHANNEL_UPDATE_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_UPDATE_FETCH_FAIL,
  TELEGRAM_CHANNEL_VIEW_FETCH,
  TELEGRAM_CHANNEL_VIEW_FETCH_SUCCESS,
  TELEGRAM_CHANNEL_VIEW_FETCH_FAIL,
} from './TelegramChannelConstants';

const initialState = {
  name: '',
  botToken: '',
  page: {},
  info: {},
  view: {},
  loading: false,
  loadingInfo: false,
  deleting: false,
  updating: false,
  retrievingData: false,
  creating: false,
  pageRequest: {},
  errors: [],
};

export default function TelegramChannelState(state = initialState, action) {
  switch (action.type) {
    case TELEGRAM_CHANNEL_LIST_FETCH:
      return { ...state, pageRequest: action.payload, loading: true };
    case TELEGRAM_CHANNEL_LIST_FETCH_SUCCESS:
      return { ...state, page: action.payload, loading: false };
    case TELEGRAM_CHANNEL_LIST_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, loading: false };
    case TELEGRAM_CHANNEL_CREATE_FETCH:
      return { ...state, creating: true };
    case TELEGRAM_CHANNEL_CREATE_FETCH_SUCCESS:
      return { ...state, creating: false };
    case TELEGRAM_CHANNEL_CREATE_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, creating: false };
    case TELEGRAM_CHANNEL_INFO_FETCH:
      return { ...state, pageRequest: action.payload, loadingInfo: true };
    case TELEGRAM_CHANNEL_INFO_FETCH_SUCCESS:
      return { ...state, info: action.payload, loadingInfo: false };
    case TELEGRAM_CHANNEL_INFO_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, loadingInfo: false };
    case TELEGRAM_CHANNEL_VIEW_FETCH:
      return { ...state, pageRequest: action.payload, retrievingData: true };
    case TELEGRAM_CHANNEL_VIEW_FETCH_SUCCESS:
      return { ...state, view: action.payload, retrievingData: false };
    case TELEGRAM_CHANNEL_VIEW_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, retrievingData: false };
    case TELEGRAM_CHANNEL_DELETE_FETCH:
      return { ...state, pageRequest: action.payload, deleting: true };
    case TELEGRAM_CHANNEL_DELETE_FETCH_SUCCESS:
      return { ...state, deleting: false };
    case TELEGRAM_CHANNEL_DELETE_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, deleting: false };
    case TELEGRAM_CHANNEL_UPDATE_FETCH:
      return { ...state, pageRequest: action.payload, updating: true };
    case TELEGRAM_CHANNEL_UPDATE_FETCH_SUCCESS:
      return { ...state, updating: false };
    case TELEGRAM_CHANNEL_UPDATE_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, updating: false };
    case TELEGRAM_CHANNEL_NAME_CHANGE_CURRENT:
      return { ...state, name: action.payload ?? '' };
    case TELEGRAM_CHANNEL_BOT_TOKEN_CHANGE_CURRENT:
      return { ...state, botToken: action.payload ?? '' };
    case TELEGRAM_CHANNEL_BATCH_SIZE_CHANGE_CURRENT:
      return { ...state, batchSize: action.payload };
    default:
      return state;
  }
}
